import React from 'react';
import { Form, Input, Button, Alert } from 'antd';

const FormItem = Form.Item;

export const phoneOtpStatusMessage = {
  required: {
    type: 'warning',
    message: 'Phone number verification is required. Click the button to send a verification code.',
  },
  sent: { type: 'success', message: 'Verification code has been sent.' },
  verified: { type: 'success', message: 'Successfully verified.' },
  errorWrongMobile: { type: 'error', message: 'Please add a valid number.' },
};

/**
 * SMS verification flow when the user edits their phone number (Admin → Settings → Edit).
 */
export function UserEditPhoneVerification({
  requireMobileVerification,
  otpStatus,
  codeSent,
  userRequest,
  codeInputRef,
  onOtpCodeChange,
  onSendOtp,
  onVerifyOtp,
  getFieldDecorator,
}) {
  return (
    <>
      {requireMobileVerification && (
        <div className="user-edit-phone-verify">
          <Alert
            type={otpStatus?.type}
            showIcon
            message={otpStatus?.message}
            className="user-edit-phone-verify-alert"
          />
          {codeSent && (
            <div className="user-edit-phone-verify-row">
              <FormItem label="Verification code" className="user-edit-phone-verify-code">
                {getFieldDecorator('otp', {
                  validateTrigger: 'onBlur',
                })(
                  <Input
                    maxLength={6}
                    onChange={onOtpCodeChange}
                    placeholder="Enter 6-digit code"
                    disabled={userRequest}
                    spellCheck={false}
                    autoComplete="one-time-code"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    ref={codeInputRef}
                  />
                )}
              </FormItem>
              <div className="user-edit-phone-verify-actions">
                <Button type="primary" loading={userRequest} disabled={userRequest} onClick={onVerifyOtp}>
                  {userRequest ? 'Verifying' : 'Verify'}
                </Button>
                <Button type="default" disabled={userRequest} onClick={onSendOtp}>
                  {userRequest ? 'Sending' : 'Resend'}
                </Button>
              </div>
            </div>
          )}
          {!codeSent && (
            <Button type="primary" loading={userRequest} disabled={userRequest} onClick={onSendOtp} block>
              {userRequest ? 'Sending' : 'Send one-time passcode'}
            </Button>
          )}
        </div>
      )}
      {otpStatus?.message === phoneOtpStatusMessage.verified.message && (
        <Alert
          type={phoneOtpStatusMessage.verified.type}
          showIcon
          message={phoneOtpStatusMessage.verified.message}
          className="user-edit-phone-verified-banner"
        />
      )}
    </>
  );
}
